import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';
import { dashboardListSelector, hasChangedMapSelector } from '@store/tempDashboard/selectors';
import { compareTabsSelector } from '@store/dashboards/tabs/selectors';
import {
  selector as commonSelector,
} from '@store/common';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import * as tabsActions from '@store/dashboards/tabs/actions';
import {
  changeSaveDashboardPromptVisibility,
  toggleUpdatePopupVisible,
  setActiveDashboardId,
} from '@store/dashboards/ui/actions';
import { selectors as sharedTabsSelector } from '@store/sharedTabs';
import { selector as defaultLandingPageSelector } from '@store/defaultLandingPage';
import {
  setDefaultLandingPage,
  showPrompt,
  setDefaultLandingPagePromptTitle,
  setDefaultLandingPagePromptContent,
  setDefaultLandingPagePromptNeedInput,
  setDefaultLandingPagePromptOkFn,
} from '@store/defaultLandingPage/actions';

import TemporaryDashboardTabs from './TemporaryDashboardTabs';

const selector = createSelector(
  dashboardListSelector,
  hasChangedMapSelector,
  compareTabsSelector,
  sharedTabsSelector,
  defaultLandingPageSelector,
  commonSelector,
  (
    dashboards,
    hasChangedMap,
    compareDashboards = [],
    sharedTabsStore,
    defaultLandingPageStore,
    commonStore,
  ) => ({
    compareDashboards,
    dashboards,
    hasChangedMap,
    features: commonStore.features,
    sharedTabs: sharedTabsStore.tabs,
    defaultLandingPage: defaultLandingPageStore,
  }),
);

export default connect(
  selector,
  {
    init: tempDashboardActions.initAtComponent,
    remove: tempDashboardActions.remove,
    removeCompareDashboard: tabsActions.triggerRemoveTab,
    replace,
    changeSaveDashboardPromptVisibility,
    toggleUpdatePopupVisible,
    setActiveDashboardId,
    setDefaultLandingPage,
    showDefaultLandingPagePrompt: showPrompt,
    setDefaultLandingPagePromptTitle,
    setDefaultLandingPagePromptContent,
    setDefaultLandingPagePromptNeedInput,
    setDefaultLandingPagePromptOkFn,
  },
)(TemporaryDashboardTabs);
